<template>
  <div id="listWidget" class="mb-5">
    <!-- <h4 class="mb-3">온도조절기 관리</h4> -->
    <!-- <p>
      방 목록을 선택하면 온도조절기 관리 화면으로 이동할 수 있습니다.
    </p> -->

    <!-- <hr class="mb-4" v-if="boilerDivices.length > 0" /> -->

    <div class="row" v-for="item in boilerDivices" :key="item._id">
      <div class="col-md-6 mb-2">
        <div class="list-group card-item" style="border-radius: 1.2rem;">
          <TempSettingListItem :device="item" :handleDeleteClick="onDeleteClick" :handleApplyClick="onApplyCalibrationClick" />
          <!-- <ListGroupItem style="padding: 0px;">
            <div class="mx-0 h-100" @click.stop="onExpandClicked">
              <i :class="`fa ${isExpand ? 'fa-chevron-up' : 'fa-chevron-down'}`" style="font-size: 0.8rem; padding-top: 15px; width:40px; height: 40px; text-align: center" />
            </div>
            <div class="flex-1 text-break" v-touch:hold="onTouchHold">
              <div style="font-size: 0.9rem">{{ item.group.name }}: {{ item.name }}</div>
            </div>
            <div @click.stop="() => onDeleteClick(item)" style="text-align: center; padding-top: 10px; width: 40px; height: 40px;">
              <i class="fa-regular fa-trash-can"></i>
            </div>
          </ListGroupItem>
          <ListGroupItem style="padding: 0px;" v-if="isExpand">
            <div class="text-break me-3" style="padding-left: 40px;">
              <div style="font-size: 0.85rem;">보정 온도값 </div>
            </div>
            <div>
              <div class="btn-group btn-group-sm" style="margin-top: 2px; margin-bottom: 2px; margin-right: 5px;">
                <button type="button" class="btn btn-outline-primary" style="width: 40px; border-radius: 7px 0px 0px 7px;" @click="onMinusClick">-</button>
                <button type="button" class="btn btn-outline-primary" style="width: 60px;">{{ calibration.toFixed(1) }}</button>
                <button type="button" class="btn btn-outline-primary" style="width: 40px; border-radius: 0px 7px 7px 0px;" @click="onPlusClick">+</button>
              </div>
            </div>
            <div class="btn-group btn-group-sm" style="margin-top: 2px; margin-bottom: 2px; padding-right: 15px;">
              <button type="button" class="btn btn-primary" style="margin-top: 2px; margin-bottom: 2px; width: 60px; border-radius: 7px 7px 7px 7px;" @click="onApplyClick(item)">적용</button>
            </div>
          </ListGroupItem> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, getCurrentInstance, computed, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import { MQTTTempCommand } from '@/common/constants';
import useMqttControl from '@/common/hooks/useMqttControl';
import Axios, { DeviceApi, CtrlApi } from '@/api';
import TempSettingListItem from './components/TempSettingListItem.vue';

const mqttControl = reactive(useMqttControl());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
const isExpand = ref(false);
const calibration = ref(0.0);

const zone = computed(() => store.getters['home/getCurrentZone']);
const groups = computed(() => zone.value?.groups || []);
const boilerDivices = computed(() => {
  let devices = [];
  groups.value.forEach(group => {
    const resultDevices = group.devices.filter(device => device.type == 2)
      .map(device => ({ group, ...device }));
    devices = [...devices, ...resultDevices];
  });
  return devices;
});
const curtainDevices = computed(() => {
  let devices = [];
  groups.value.forEach(group => {
    const resultDevices = group.devices.filter(device => device.type == 3)
      .map(device => ({ group, ...device }));
    devices = [...devices, ...resultDevices];
  });
  return devices;
});

const requestDeleteDevice = async (device) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.delete(
        DeviceApi.DELETE_DEVICE.replace(':id', device._id),
      );
      if (result.resultCode === '0000') {
        store.commit('home/deleteDevice', {
          zoneId: parseInt(zone.value._id),
          groupId: parseInt(device.group._id),
          deviceId: device._id,
        });
        resolve(true);
        return;
      }
      reject("장치 삭제에 실패했습니다.");
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};

const requestDeleteController = async (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.delete(
        CtrlApi.DELETE_CTRL.replace(':id', id),
      );
      if (result.resultCode === '0000') {
        store.commit('home/deleteController', {
          zoneId: zone.value._id,
          controllerId: id,
        });
        resolve(true);
        return;
      }
      reject("온도조절기 삭제에 실패했습니다.");
    } catch (error) {
      console.log(error)
      reject(error);
    }
  });
};

const onDeleteClick = (boiler) => {
  const curtains = curtainDevices.value.filter((curtainDevice) => curtainDevice.controllerId == boiler.controllerId);
  const deleteDevices = curtains.length > 0 ? [boiler, ...curtains] : [boiler];
  const description = curtains.length > 0 ? "커튼이 포함된 장치입니다.\n커튼을 포함하여 전부 삭제하시겠습니까?" : "정말 삭제하시겠습니까?";

  emitter.emit('showPopConfirm', {
    description,
    okCallback: async () => {
      try {
        await Promise.all(deleteDevices.map((device) => requestDeleteDevice(device)));
        await requestDeleteController(boiler.controllerId);

        emitter.emit('showPopAlert', {
          description: "온도조절기가 삭제되었습니다.",
        });
      } catch (e) {
        emitter.emit('showPopAlert', {
          description: e,
        });
      }
    }
  });
}

const requestUpdateDevice = async (device, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.patch(
        DeviceApi.UPDATE_DEVICE.replace(':id', device._id),
        params,
      );
      if (result.resultCode === '0000') {
        console.log(result.resultData);
        store.commit('home/updateDevice', {
          groupId: device.group._id,
          id: device._id,
          data: params,
        });
        
        resolve(true);
        return;
      }
      reject("장치 삭제에 실패했습니다.");
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};

const onApplyCalibrationClick = async (boiler, calibration) => {
  await requestUpdateDevice(boiler, { item: { calibration } });
  mqttControl.onPublishTemp(boiler.controllerId, MQTTTempCommand.TempCalibrationSet, `${calibration * 10}`);
}

onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title:'온도 조절기 관리',isShowMenu:false,isShowZone:false,isShowProfile:false,isShowRightHome:true});    
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true,isShowRightHome:false});  
})    
</script>
